export const MICROSOFT_DRIVE_FILE_URL_REGEX =
	'https:\\/\\/onedrive.live.com(?:\\/.*?(?:\\&|\\?)(?:id=|resid=))(.+?)(?:\\&.*)';

export const MICROSOFT_DRIVE_FOLDER_URL_REGEX =
	'https:\\/\\/onedrive.live.com(?:\\/.*id=)(.+)(?:\\&cid.*)';
